import router from "./router";
import i18n from "./i18n";

export const trainingModuleRouter = router;
export const trainingModuleI18n = i18n;
